export const MODULE_NAME = 'axp-travel-search-rooms-travelers';
